<template>
  <div class="show-main" @mousewheel.stop v-if="show">
    <transition name="option">
      <div class="cover" style="opacity: 0;" v-if="show" @click="close"></div>
    </transition>
    <div class="pos" v-if="show">
      <div class="main" v-if="show">
        <div class="cv">
          <transition name="opacity">
            <skeleton :type="3" v-if="resumeSkeleton" style="height: 100%;"/>
          </transition>
          <resume :need-set-one-page="false"
            @nextTick="resumeSkeleton = false"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import resume from './resume';
import skeleton from '@/components/cvs/editor/img';
export default {
  name: 'show',
  components: {
    resume,
    skeleton
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      resumeSkeleton: true
    }
  },
  methods: {
    close() {
      this.$emit('close');
      this.resumeSkeleton = true;
    }
  },
}
</script>
<style lang="scss" scoped>
  $width: 540px;
  $s: 210 / 297;
  .show-main {
    width: 100vw;
    height: 100vh;
    // min-height: $width / $s;
    margin: 0;
    padding: 0;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    overflow: auto;
    background: rgba(0, 0, 0, 0.5);
    .cover {
      width: 100vw;
      height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
    }
    .pos {
      width: 100vw;
      height: 100vh;
      max-width: 856px;
      max-height: $width / $s;
      width: $width;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 12;
      margin: auto;
      overflow: auto;
    }
    .main {
      // padding: 10px 0;
      // width: 856px;
      width: $width;
      height: $width / $s;
      // height: 100%;
      overflow: auto;
      position: relative;
      z-index: 2;
      // position: absolute;
      // top: 0;
      // left: 0;
      // right: 0;
      // bottom: 0;
      // margin: auto;
      display: flex;
      .cv {
        box-sizing: border-box;
        width: $width;
        height: 100%;
        // height: $width / $s;
        overflow-y: auto;
        position: relative;
      }
      .edit {
        width: 300px;
        height: 100%;
        // height: $width / $s;
        margin-left: 16px;
      }
    }
  }
</style>
